import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const SideCollapseWrapper = styled.div`
  position: absolute;
  left: 20px;
  top: 80px;
  bottom: 80px;
  max-width: 280px;
  width: 100%;
  z-index: 600;
`

const SideCollapseContent = styled.div`
  width: 100%;
  max-height: 100%;
  background-color: #F6F6F6;
  border-radius: 10px;
`

const SideCollapse = ({ children, show }) =>
  <SideCollapseWrapper show={show}>
    <SideCollapseContent>
      {children}
    </SideCollapseContent>
  </SideCollapseWrapper>

SideCollapse.propTypes = {
  children: PropTypes.node.isRequired,
  show: PropTypes.bool.isRequired,
  width: PropTypes.number.isRequired
}

export default SideCollapse



// WEBPACK FOOTER //
// ./src/components/atoms/SideCollapse/SideCollapse.js